export const NAME_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù' ]*$/;
export const MOBILE_PATTERN = /^(\((00|\+)39\)|(00|\+)39)?\d{9,10}$/;
export const VAT_NUMBER_PATTERN = /^([a-zA-Z]{2})?[0-9]{11}$/;
export const POD_PATTERN = /^IT\d{3}E\d{8}\d?$/;
export const FISCAL_CODE_PATTERN = /^[A-Za-z]{6}[\dLMNP-Vlmnp-v]{2}[A-Za-z][\dLMNP-Vlmnp-v]{2}[A-MZamz][\dLMNP-Vlmnp-v]{3}[A-Za-z]/;
export const PROVIDER_PATTERN = /^[a-zA-Z0-9ÀÈÌÒÙàèìòù'& /-]*$/;
export const EMAIL_PATTERN = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,4}$/;
